import { render, staticRenderFns } from "./adplan-file-confirmation.vue?vue&type=template&id=12627a64"
import script from "./adplan-file-confirmation.vue?vue&type=script&lang=js"
export * from "./adplan-file-confirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports